import {Route, Routes} from 'react-router-dom';

import LoadingSpinner from 'src/components/LoadingSpinner';
import PageContainer from 'src/components/PageContainer';
import PageTitle from 'src/components/PageTitle';
import {useTranslations} from 'src/components/TranslationsContext'; // added import
import {useCurrentOrganization} from 'src/hooks/useAuth';
import useOrganizationUsersQuery from 'src/hooks/useOrganizationUsers';
import {ApiUserProfile} from 'src/lib/api/auth';

import User from './User';
import Users from './Users';

type Props = {
  currentUser: ApiUserProfile;
};

export default function UsersPage({currentUser}: Props) {
  const {t} = useTranslations();
  const currentOrg = useCurrentOrganization()!;
  const query = useOrganizationUsersQuery(currentOrg.id);

  let content;
  if (query.isLoading) {
    content = (
      <>
        <PageTitle
          pageStack={[
            {title: currentOrg.name, to: '/:currentOrgIdPrefix/projects'},
            {title: t('settings'), to: '/:currentOrgIdPrefix/settings'},
            {title: t('team'), to: '/:currentOrgIdPrefix/settings/users'},
          ]}
        />
        <LoadingSpinner />
      </>
    );
  } else {
    const users = query.data ?? [];
    content = (
      <Routes>
        <Route
          index
          element={<Users currentUser={currentUser} users={users} organization={currentOrg} />}
        />
        <Route
          path=":userId/*"
          element={<User currentUser={currentUser} users={users} organization={currentOrg} />}
        />
      </Routes>
    );
  }
  return <PageContainer>{content}</PageContainer>;
}
